import { useState } from 'react'
import { createModel } from 'hox'
import useStorageState from '../hooks/useStorageState'
import { IPgProps, ISelectOptions } from '@/types/ScmTypes'
import { PaginationProps } from 'antd/es/pagination'
import { CLIENT_APP_CODE, defaultMdCmParam } from '@/utils/constants'
import { ISelectOption } from '@/components/YhFormBox/Types'
import { supplierService } from '@/views/supplier/supplierService'

export function transPgToPagination(pg: IPgProps): PaginationProps {
    return {
        total: pg.total,
        pageSize: pg.size,
        current: pg.current,
    }
}

export function fn(): Promise<ISelectOption[]> {
    let arr: ISelectOption[] = []
    return Promise.resolve(arr)
}

export type RoleType = {
    id: string
    name: String
}
export type UserType = {
    id: string
    userName: string
    password: String
    token: string
    shopId: string
    shopName: string
    shopCode: string
    loginType?: 'account' | 'token'
    [key: string]: any
}

export type LoadingType = { loadingVisible: boolean; txt: string }
const initUserState = {
    id: "",
    userName: "",
    password: "",
    token: "",
    shopId: "",
    shopName: "",
    shopCode: ""
}

type GlobalModelType = {
    user: UserType
    setUser: (e: UserType) => void
    resetUser: () => void
    loadingInfo: LoadingType
    setLoadingInfo: (origin: LoadingType) => void
    curentUser: string
    setCurentUser: (value: string) => void
    cm: CmType
    resetCm: () => void
    toggleMenu: () => void,
    fetchSupplierList: (value: string) => Promise<ISelectOption[]>,
}

const initCmState = {
    collapsed: false
}


type CmType = {
    collapsed: boolean
}

function useModel(): GlobalModelType {
    //用户所有信息
    const [user, setUser, resetUser] = useStorageState<UserType>('user', initUserState)

    const [cm, setCm, resetCm] = useStorageState<CmType>('cm', initCmState);
    // 当前登录用户
    const [curentUser, setCurentUser] = useStorageState<string>('current', '')

    //全局loading
    const [loadingInfo, setLoadingInfo] = useState<LoadingType>({ loadingVisible: false, txt: '' })
    const toggleMenu = () => {
        setCm({
            ...cm,
            collapsed: !cm.collapsed
        })
    }

    //实时查询客户接口
    const fetchSupplierList = async (value: string) => {
        let data = { pageSize: 15, pageNum: 1, name: value, enable: 0 };
        return supplierService.page(data).then(res => {
            const { retData: { records } } = res;
            return records ? records.map(item => ({
                key: item.id,
                id: item.id,
                label: item.name,
                value: item.code,
            })) : [];
        })
    }

    return {
        user,
        setUser,
        resetUser,
        loadingInfo,
        setLoadingInfo,
        curentUser,
        setCurentUser,
        cm,
        resetCm,
        toggleMenu,
        fetchSupplierList
    }
}

export const useGlobalModel = createModel(useModel)
export default useGlobalModel
